exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tree-list-blobs .file-row-name {\n  margin-left: 12px;\n}\n", ""]);

